<template>
  <div :style="style" class="p-3">
    <h4
      class="text-color text-sm font-bold"
      :data-id="service.id"
      :data-duration="service.duration"
    >
      {{ service.name }}
    </h4>
    <p v-if="service.description" class="text-gray-500 text-13px">
      {{ service.description }}
    </p>
    <sameday-availability
      :settings="settings"
      :availabilities="availability"
      @on:form="onForm"
    ></sameday-availability>
  </div>
</template>

<script>
import SamedayAvailability from "@/components/Sameday/SamedayAvailability.vue";

export default {
  components: {
    SamedayAvailability,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    settings() {
      return this.params?.location?.settings;
    },
    service() {
      return this.params?.service;
    },
    availability() {
      return this.params?.availability;
    },
    style() {
      return {
        "--text-color":
          this.$store.state.config.colors.samedayCardServiceTitleColor ||
          "#212127",
      };
    },
  },
  methods: {
    onForm(value) {
      this.$emit("on:form", {
        ...value,
        location: this.params?.location,
        service: this.params?.service,
        provider_id: this.params?.provider_id,
      });
    },
  },
};
</script>

<style scoped>
.text-color {
  color: var(--text-color);
}
.text-13px {
  font-size: 13px;
}
</style>
